<template>
<v-form ref="formSelect">
  <v-select
      v-model="item"
      :items="items"
      :label="itemAction.name"
      :item-text="itemText"
      item-value="id"
      clearable
      outlined
      dense>
      <template v-slot:selection="{ item }">
        <v-list-item-action-text dense>
          <span class="font-weight-bold subtitle-2" >{{ itemText(item) }}</span>
        </v-list-item-action-text>
      </template>

      <template v-slot:item="{ item }">
        <v-list-item-action-text dense>
          <span class="font-weight-bold font-weight-black">{{ itemText(item) }}</span>
        </v-list-item-action-text>
      </template>
  </v-select>
</v-form>

</template>

<script>
import axios from 'axios'
import { DatesUtils } from '@/mixins/datesUtilsMixin'
export default {
  mixins: [DatesUtils],
  props: ['itemAction', 'onSuccess', 'setterModel'],
  data: () => ({
    item: null,
    items: []
  }),
  created () {
    if (this.itemAction.url) {
      this.getDinamicData(this.itemAction.url)
    }
  },
  methods: {
    itemText (item) {
      if (item && (this.itemAction.nameid === 'tipo_plaza_id' || this.itemAction.nameid === 'rol_id' ||
        this.itemAction.nameid === 'zona_id' || this.itemAction.nameid === 'banco_id')) {
        return `${item.nombre}`
      } else if (item && this.itemAction.nameid === 'plaza_id') {
        return `${item.NombreCompleto}`
      } else if (item && this.itemAction.nameid === 'cuenta_id') {
        const cuenta = (item.cuenta !== '') ? item.cuenta : item.clabe
        return `${item.banco.nombre} - ${cuenta}`
      } else if (item && this.itemAction.nameid === 'ejercicio_id') {
        return `${item.descripcion}`
      }
      return 'No Title'
    },
    getDinamicData (url) {
      const token = this.$cookies.get('token_sirh')
      axios.post(url, this.itemAction.params, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        this.items = []
        this.items.push(...response.data)
      }).catch(error => {
        if (error == null) {}
      })
    },

    setDefault (items) {
      if (this.itemAction.default) {
        if (this.itemAction.nameid === 'ejercicio_id') {
          // const year = this.getYear()
          const year = new Date().toISOString().substr(0, 4)
          items.map(periodo => {
            if (periodo.anio >= year) {
              this.item = periodo.id
            }
          })
        }
      }
    }

  },
  watch: {
    item (val) {
      this.onSuccess({ id: this.itemAction.nameid, data: val })
    },
    items (vals) {
      if (this.setterModel) {
        this.item = this.setterModel
      } else {
        this.setDefault(vals)
      }
    }
  }
}
</script>

<style>
</style>
